import React from 'react'
import { createRoot } from 'react-dom/client'
import { createPortal } from 'react-dom'
import { register } from './serviceWorker'
import ModalContainer from 'react-modal-promise'
import { ConfigProvider, App, theme } from 'antd'

import TApp from './components/App/App'

import './index.scss'

const rootContainer = document.getElementById('root')
const overlayContainer = document.getElementById('overlay_container')
const root = createRoot(rootContainer!)

root.render(<React.StrictMode>
    <ConfigProvider
        theme={{
            algorithm: theme.darkAlgorithm,  // 🌙 enable dark mode
        }}
    >
        <App>
            <TApp />
        </App>
    </ConfigProvider>
    {createPortal(<ModalContainer />, overlayContainer!)}
</React.StrictMode>,)

register({
  onUpdate: (reg) => console.log('SW updated', reg),
  onSuccess: (reg) => console.log('SW registered', reg)
})

